import { render, staticRenderFns } from "./SideDialogWork.vue?vue&type=template&id=d5010efe&scoped=true&"
import script from "./SideDialogWork.vue?vue&type=script&lang=js&"
export * from "./SideDialogWork.vue?vue&type=script&lang=js&"
import style0 from "./SideDialogWork.vue?vue&type=style&index=0&id=d5010efe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5010efe",
  null
  
)

component.options.__file = "SideDialogWork.vue"
export default component.exports